import type { ApexOptions } from 'apexcharts'
import type { SectionMetrics } from '../../../features/engagement/domain/models/sections'
import { buildHorizontalBarChartOptions, ChartColors } from '../../shared/charts'
import { SECTION_LABEL_KEYS, type TranslateFn } from './section-display'

// Visits per section, ranked descending: includes 'other'
export const getSectionsVisitsBarsOptions = (sections: SectionMetrics[], t: TranslateFn): ApexOptions => {
  const ranked = [...sections].sort((a, b) => b.visits.current - a.visits.current)

  return buildHorizontalBarChartOptions({
    categories: ranked.map((s) => t(SECTION_LABEL_KEYS[s.section])),
    seriesName: t('ls_sections_visits'),
    data: ranked.map((s) => s.visits.current),
    color: ChartColors.blue
  })
}
